export default "/img/UG.0673487a714aa2396f9099495686bda9.png";